import ClearableInput from '@rio-cloud/rio-uikit/components/clearableInput/ClearableInput';
import { useIntl } from 'react-intl';

import { useDebounce } from '@/hooks/useDebounce';
import { useSendQuestionMutation } from '@/services/chatApi/chatApi';

import { SearchFieldProps } from './types';

const SearchField = ({ onSearch, shouldUseDebounce = true }: SearchFieldProps) => {
  const intl = useIntl();
  const debouncedSearch = useDebounce(onSearch);
  const [, { isLoading: isSendMessageLoading }] = useSendQuestionMutation();


  return (
    <div className="form-group padding-x-20">
      <div className="input-group">
        <span className="input-group-addon">
          <span className="rioglyph rioglyph-search" aria-hidden="true" />
        </span>
        <ClearableInput
          data-testid="thread-search-input"
          placeholder={intl.formatMessage({ id: 'chatPage.searchList.placeholder' })}
          onChange={shouldUseDebounce ? debouncedSearch : onSearch}
          disabled={isSendMessageLoading}
        />
      </div>
    </div>
  );
};

export default SearchField;
